import { render, staticRenderFns } from "./ModalSwitchCustomer.vue?vue&type=template&id=4159a156&scoped=true"
import script from "./ModalSwitchCustomer.vue?vue&type=script&lang=js"
export * from "./ModalSwitchCustomer.vue?vue&type=script&lang=js"
import style0 from "./ModalSwitchCustomer.vue?vue&type=style&index=0&id=4159a156&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4159a156",
  null
  
)

export default component.exports